import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteCookiesComponent} from './website-cookies.component'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {SharedModule} from '../shared/shared.module'
import {RouterModule} from '@angular/router'
@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    SharedModule,
    RouterModule,
  ],
  declarations: [WebsiteCookiesComponent],
  exports: [
    WebsiteCookiesComponent
  ],
  providers: []
})
export class WebsiteCookiesModule {
}
